import React from "react";
import AuditLogView from "@/components/AuditLogView";

// Jurnalul de licențiere al superadminului (backend: GET /api/audit/licensing).
export default function LicensingAudit() {
  return <AuditLogView endpoint="/audit/licensing" title="Jurnal licențiere" testid="licensing-audit"
    subtitle="Acțiunile de licențiere: clienți, conturi de Admin, licențe, kituri de instalare, prețuri, comutatoare, exporturi." />;
}
